import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import { SaveOutlined } from '@material-ui/icons';
import Pagination from '@material-ui/lab/Pagination';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// import ButtonExcel from '@components/Shared/ExportExcel';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { Empty } from 'antd';
import '@styles/AntStyles.css';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {
  DivLoading,
  SpinnerLoadingMaterial,
  StyledTableCell,
  StyledTableCell2,
  StyledTableCell3,
  StyledTableCell0,
  StyledTableRow,
  useStyles,
  ItemPaginate,
  BottomPagination,
  BootstrapInput,
  Container,
  DivVoid,
  StyledTableRow2,

} from './styles';
import {Box, Collapse, IconButton, Grid } from '@material-ui/core';

interface ITableProps {
  data: object[];
  columns: Object[];
  loading: Boolean;
  ActionHeader?: string;
  itemsPerPage: number;
  fetchData: Function;
  pageCurrent: number;
  totalPages: number;
  Actions?: IActionObj[];
  Selected?: Function;
  FieldsBold?: string[];
  keys: string[];
  totalItens?: number;
}

interface IActionObj {
  Button: Function;
}

const TableColapse: React.FC<ITableProps> = ({
  data,
  columns,
  loading,
  itemsPerPage,
  fetchData,
  pageCurrent,
  totalPages,
  Actions,
  ActionHeader,
  Selected,
  FieldsBold,
  keys,
  totalItens,
}) => {
  const classes = useStyles();
  // const keys = Object.keys(data[0] || data);
  const alterColumns = columns[0] || {};

  const [statusSelected, setStatusSelected] =
  React.useState<string>('');

  const Head = ({ keys, alterColumns }: any) => {
    return (
      <>
        {Selected && (
          <StyledTableCell align="center">Selecionar</StyledTableCell>
        )}

        {keys.map((key: any) => (
          <StyledTableCell key={key} align="center">
            {alterColumns[key] || key}
          </StyledTableCell>
        ))}

        {Actions && (
          <StyledTableCell align="center">
            {ActionHeader !== null ? ActionHeader : 'Opções'}
          </StyledTableCell>
        )}
      </>
    );
  };

  const Rows = ({ row }: any) => {
    const colunas = Object.keys(row);
    const [open, setOpen] = React.useState(false);

    return (
      <>
        <StyledTableRow>
          <StyledTableCell align="right">{row.Data}</StyledTableCell>
          <StyledTableCell align="right"> <strong> {row.Tipo_Informacao} </strong></StyledTableCell>
          <StyledTableCell align="right">{row.Usuario}</StyledTableCell>
          <StyledTableCell0>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </StyledTableCell0>
        </StyledTableRow>
        <StyledTableRow>
          <StyledTableCell
            style={{ paddingBottom: 0, paddingTop: 0, padding: 0 }}
            colSpan={7}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Table className={classes.table}>
                <TableBody>
                  {row.Campo.map((observacao: any) => (
                    <StyledTableRow2 key={observacao.date}>
                      <StyledTableCell2>{observacao.Coluna}</StyledTableCell2>
                      <StyledTableCell3>{observacao.Valor}</StyledTableCell3>
                    </StyledTableRow2>
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </StyledTableCell>
        </StyledTableRow>
      </>

    );
  };

  const handleChangePage = async (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    await fetchData(value, itemsPerPage);
  };

  const handleChangeItemsPerPage = async (
    event: React.ChangeEvent<{ value: unknown }>,
  ) => {
    const value = event.target.value as number;
    await fetchData(pageCurrent, value);
  };

  const reloadTable = async () => {
    await fetchData(pageCurrent, itemsPerPage);
  };

  return (
    <Container>
      <Grid item lg={12} xs={12}>

      </Grid>
      {/* <div
        style={{ height: 'auto', display: 'flex', justifyContent: 'flex-end ' }}
      >
        <ButtonExcel title="Tabela" data={data} keys={keys} labels={columns[0]}>
          <IconButton>
            <CloudDownloadIcon fontSize={'large'} />
          </IconButton>
        </ButtonExcel>
      </div> */}

      {loading && (
        <DivLoading>
          <SpinnerLoadingMaterial />
        </DivLoading>
      )}

      {!loading && data.length <= 0 && (
        <DivVoid>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhum dado encontrado"
          />
        </DivVoid>
      )}

      <TableContainer className={classes.container}>
        <Table className={classes.table} stickyHeader size="medium">
          {!loading && (
            <TableHead>
              <TableRow>
                <Head keys={keys} alterColumns={alterColumns} />
              </TableRow>
            </TableHead>
          )}

          <TableBody>
            {data.map((row: any, index: number) => {
              return <Rows key={index} row={row} />;
            })}
          </TableBody>
          <TableFooter></TableFooter>
        </Table>
      </TableContainer>

      <BottomPagination>
        <ItemPaginate>
          <Pagination
            size="small"
            count={totalPages}
            page={pageCurrent}
            color="primary"
            onChange={handleChangePage}
          />
        </ItemPaginate>
        <ItemPaginate>
          <p> linhas por página: </p>

          <Select
            value={itemsPerPage}
            onChange={handleChangeItemsPerPage}
            defaultValue={itemsPerPage}
            input={<BootstrapInput />}
          >
            {/* <MenuItem selected value={5}>
              5
            </MenuItem> */}
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </ItemPaginate>
        <ItemPaginate>{totalItens && <p>Total: {totalItens}</p>}</ItemPaginate>
      </BottomPagination>
    </Container>
  );
};

export default TableColapse;
